export var ServerMode;
(function (ServerMode) {
    ServerMode["D"] = "1";
    ServerMode["S"] = "2";
    ServerMode["P"] = "3";
    ServerMode["Unknown"] = "1000";
})(ServerMode || (ServerMode = {}));
